
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper(".webvibe-reviews-slider", {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        speed: 1500,
        effect: "flip", //"slide" | "fade" | "cube" | "coverflow" | "flip" | "creative" | "cards"
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });

});

gsap.registerPlugin(ScrollTrigger);

function initReviewsSection(section) {
    if (section.dataset.wvAnimInited === "1") return;
    section.dataset.wvAnimInited = "1";

    const title = section.querySelector("h2.global_title");
    const slider = section.querySelector(".webvibe-reviews-slider");

    // initial state
    if (title) gsap.set(title, { autoAlpha: 0, y: 40 });
    if (slider) gsap.set(slider, { autoAlpha: 0, scale: 0.96, y: 30 });

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "top 75%",
            once: true,
        },
    });

    if (title) {
        tl.to(title, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: "power3.out",
        });
    }

    if (slider) {
        tl.to(
            slider,
            {
                autoAlpha: 1,
                scale: 1,
                y: 0,
                duration: 1,
                ease: "power4.out",
            },
            0.2
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document
        .querySelectorAll(".wp-block-blocks-webvibe-block-reviews")
        .forEach(initReviewsSection);
});